import { stegaClean } from '@sanity/client/stega';

const LOCALES: Record<string, string> = {
  en: 'en-US',
  de: 'de-DE',
  br: 'pt-BR',
};

export function formatBlogDate(iso: string, language?: string): string {
  const date = new Date(stegaClean(iso));
  if (Number.isNaN(date.getTime())) return '';

  const locale = LOCALES[stegaClean(language) ?? ''] ?? LOCALES.en;
  return date.toLocaleDateString(locale, {
    month: 'long',
    day: 'numeric',
    year: locale === LOCALES.en ? '2-digit' : 'numeric',
    timeZone: 'Europe/Berlin',
  });
}

export default formatBlogDate;
